import {useStore} from "vuex";
import {computed} from "vue";

const useOpportunityStore = () => {
  const store = useStore();

  const search = computed(() => store.getters['backlinkOpportunity/search']);
  const orderBy = computed(() => store.getters['backlinkOpportunity/orderBy']);
  const orderDirection = computed(() => store.getters['backlinkOpportunity/orderDirection']);
  const activeTab = computed(() => store.getters['backlinkOpportunity/activeTab']);
  const activeCompetitor = computed(() => store.getters['backlinkOpportunity/activeCompetitor']);

  return {
    search,
    orderBy,
    orderDirection,
    activeTab,
    activeCompetitor
  };
};

export default useOpportunityStore;
